import { UpdateTeamWorkspaceAlias } from '@prophecy/queries/pages/Team/queries';
import { makeGraphQlCall } from 'frontend/core/src/data/util';

export const updateWorkspaceName = (teamID: string, workspaceAlias: string) => {
  return makeGraphQlCall(UpdateTeamWorkspaceAlias, {
    teamUID: teamID,
    workspaceAlias
  });
};
